import { render } from "./login-page.vue?vue&type=template&id=5d6adfa0&ts=true"
import script from "./login-page.vue?vue&type=script&lang=ts"
export * from "./login-page.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__